module.exports = __webpack_public_path__ + "img/jr1.1ac198fc.png";